import React from "react";
import Box from "@mui/material/Box";
import ComparedSalesInsightAreaHospitality from "./ComparedSalesInsightAreaHospitality";
import ComparedSalesByLocation from "./ComparedSalesByLocation";
import ComparedNetSalesAndTransactions from "./ComparedNetSalesAndTransactions";
import ComparedTransactionsByLocation from "./ComparedTransactionsByLocation";
import ComparedSalesByStaff from "./ComparedSalesByStaff";
import ComparedSalesByTender from "./ComparedSalesByTender";
import ComparedSalesByLocationPieBar from "./ComparedSalesByLocationPieBar";
import ComparedTransactionsByLocationPieBar from "./ComparedTransactionsByLocationPieBar";


const ComparedHospitalityBusinessDashboard = () => (
        <Box sx={{ width: '100%', flexGrow: 1, height: 'auto'}}>
            <Box>
                <ComparedSalesInsightAreaHospitality/>
            </Box>
            <Box sx={{display:'flex', flexDirection:'row', width:'auto', justifyContent: 'space-between' }}>
                <Box sx={{width: '50%'}}>
                    <ComparedSalesByLocation/>
                </Box>
                <Box sx={{width: '50%'}}>
                    <ComparedTransactionsByLocation/>
                </Box>
            </Box>
            <Box sx={{ width:'auto', marginY: '20px'}}>
                <ComparedNetSalesAndTransactions/>
            </Box>
            <Box sx={{display:'flex', flexDirection:'row', width:'auto', justifyContent: 'space-between', marginY: '20px'}}>
                <Box sx={{width: '33.3%'}}>
                    <ComparedSalesByLocationPieBar />
                </Box>
                <Box sx={{width: '33.3%'}}>
                    <ComparedTransactionsByLocationPieBar />
                </Box>
                <Box sx={{width: '33.3%'}}>
                    <ComparedSalesByStaff />
                </Box>
            </Box>
            <Box sx={{ width:'auto', marginY: '20px'}}>
                <ComparedSalesByTender/>
            </Box>
        </Box>
        
        
    );

export default ComparedHospitalityBusinessDashboard;
